import type { WatchCompany } from './types';

export function toWatchCompanyImport(company: WatchCompany) {
  return {
    name: company.name,
    code: company.code,
    uid: company.uid,
    aliases: company.aliases,
    ownership: company.ownership,
    dateOpened: company.dateOpened,
    dateClosed: company.dateClosed,
    naceSection: company.naceSection,
    naceCode: company.naceCode,
    euTaxonomyCode: company.euTaxonomyCode,
    addressCountry: company.addressCountry,
    addressState: company.addressState,
    addressCity: company.addressCity,
    addressPostCode: company.addressPostCode,
    addressStreet: company.addressStreet,
    addressBuilding: company.addressBuilding,
    addressCoordinates: company.addressCoordinates,
    website: company.website,
    notes: company.notes,
    identifiers: company.identifiers,
    products: company.products.map(({ id: _id, ...product }) => product),
    buildings: company.buildings.map(({ id: _id, ...building }) => building),
    orgNodes: company.orgNodes.map((node) => ({
      key: `node-${node.id}`,
      name: node.name,
      role: node.role,
      parentKey: node.parentId == null ? null : `node-${node.parentId}`,
      ownershipPct: node.ownershipPct,
    })),
    associations: company.associations.map(({ id: _id, ...row }) => row),
    financials: company.financials.map(({ id: _id, ...row }) => row),
  };
}

export function skeletonWatchCompanyImport() {
  return {
    schemaVersion: '1',
    exportedAt: new Date().toISOString(),
    sourceWatchCompanyId: null,
    companies: [{
      name: '',
      code: '',
      uid: '',
      aliases: [],
      addressCountry: '',
      identifiers: [{ scheme: 'lei', value: '' }],
      products: [{ name: '', code: '', uid: '' }],
      buildings: [{ name: '', uid: '' }],
      orgNodes: [{
        key: 'legal',
        name: '',
        role: 'legal_entity',
        parentKey: null,
      }],
      associations: [],
      financials: [],
    }],
  };
}
